export default {
  "alignLeft": "b6Yvr",
  "textWrapNowrap": "SlPr5",
  "alignRight": "SNK9x",
  "alignCenter": "_7UtOR",
  "sizeFullWidth": "Sa5hy",
  "renderedInTable": "_1-ahk",
  "sizeOriginal": "XSWDE",
  "sizeContent": "O2XNb",
  "sizeSmall": "bMSol",
  "sizeSmallCenter": "_66T-v",
  "flex": "S791g",
  "atomic": "WZXNP",
  "embed": "XmCy4",
  "horizontalScrollbar": "YVngk",
  "pluginContainerMobile": "zrt-O"
};